"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.random_rgb_color = random_rgb_color;
/**
 * @returns random rgb colour
 */
function random_rgb_color() {
    const x = Math.floor(Math.random() * 256);
    const y = Math.floor(Math.random() * 256);
    const z = Math.floor(Math.random() * 256);
    return 'rgb(' + x + ',' + y + ',' + z + ')';
}
